import { TileWMS, Vector as VectorSource, BingMaps } from "ol/source.js";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer.js";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style.js";
import GoogleLayer from "olgm/layer/Google.js";

let baseURL = "https://sksoilgis1.usask.ca/geoserver/sksoil/wms";

// Open Street Basemap
export let openStreeMap = new TileLayer({
  visible: true,
  source: new BingMaps({
    key: "AjuiTz-K1RGALYtpTD5ikQXwQjDIkKGqaxBh-cNJA8BxPcdzxLyTQ4c-RInRBTE7",
    imagerySet: "AerialWithLabels"
  })
  // source: new OSM()
});
openStreeMap.name = "OpenStreet";
openStreeMap.id = 0;

export let googleMap = new GoogleLayer({
  visible: false,
  mapTypeId: google.maps.MapTypeId.HYBRID
});
googleMap.name = "Google";
googleMap.id = 1;

export let pointsLayer = new TileLayer({
  visible: false,
  name: "Economic Regions",
  id: 1,
  source: new TileWMS({
    url: baseURL,
    params: {
      VERSION: "1.1.1",
      tiled: true,
      LAYERS: "sksoil:ecoregions"
    },
    serverType: "geoserver"
  })
});

export let drawSource = new VectorSource({
  wrapX: false
});

export let drawLayer = new VectorLayer({
  visible: false,
  name: "Draw",
  id: 5,
  source: drawSource,
  style: function(f) {
    var style = new Style({
      stroke: new Stroke({
        color: "blue",
        width: 2
      })
    });
    return [style];
  }
});

export let nodeSource = new VectorSource({
  wrapX: false
});

export let nodesLayer = new VectorLayer({
  visible: false,
  name: "Draw",
  id: 3,
  source: nodeSource,
  style: function(f) {
    var style = new Style({
      image: new CircleStyle({
        radius: 6,
        fill: new Fill({ color: "rgba(255, 0, 0, 0.3)" }),
        stroke: new Stroke({ color: "red", width: 2 })
      })
    });
    return [style];
  }
});

export let basemaps = [googleMap, openStreeMap];

export let layers = [pointsLayer, drawLayer, nodesLayer];



// WEBPACK FOOTER //
// ./src/geo_config.js